import { ResourceNotAvailablePlaceholder } from "@/app/components/cards/ResourceNotAvailablePlaceholder";
import { Box, Card } from "@mantine/core";
import QuestionHeader from "./Header/QuestionHeader";
import { useQuestionBodyStyles } from "./Question/QuestionBody";
import Wrapper from "./Question/Wrapper";
import { useQuestionStyles } from "./QuestionModule";

export default function PreviewQuestionModule({
  subjectColorIndex,
}: {
  subjectColorIndex: string;
}) {
  const { classes: questionClasses } = useQuestionStyles({
    userHasAdminEditAccess: false,
    shouldHideQuestion: false,
    isPreviewPortal: undefined,
    topicDocumentId: undefined,
    testId: undefined,
  });
  const { classes: questionBodyClasses } = useQuestionBodyStyles();
  return (
    <Card className={questionClasses.card} mb="10rem">
      <QuestionHeader
        indx={"In Development"}
        subjectColorIndex={subjectColorIndex}
        requiresCalc={false}
      />
      <Wrapper className={questionBodyClasses.questionWrapper}>
        <Box h={200} pos="relative">
          <ResourceNotAvailablePlaceholder
            reason="in development"
            resource="questions"
            subjectColorIndex={subjectColorIndex}
          />
        </Box>
      </Wrapper>
    </Card>
  );
}
